// src/components/onboarding/screens/EtatScreen.js
import React from 'react';
import OnboardingLayout from '../OnboardingLayout';
import { RadioItem, SectionBox, ScreenTitle } from '../OnboardingUI';
import { getEtatPersoOptions, etatExterieurOptions, TOTAL_STEPS } from '../onboardingData';

const EtatScreen = ({ etatPerso, etatExterieur, genre, onChange, onNext, loading, error }) => {
  const etatPersoOptions = getEtatPersoOptions(genre);
  const canProceed = etatPerso !== '' && etatExterieur !== '';

  return (
    <OnboardingLayout
      currentStep={4}
      totalSteps={TOTAL_STEPS}
      canProceed={canProceed}
      onNext={onNext}
      loading={loading}
      error={error}
    >
      <ScreenTitle title='Quand on te parle de "ce que tu veux faire plus tard"...' />

      <SectionBox variant="gray" icon="🪞" label="Toi, tu es plutôt :">
        {etatPersoOptions.map(option => (
          <RadioItem
            key={option.value}
            checked={etatPerso === option.value}
            label={option.label}
            sublabel={option.sub}
            onClick={() => onChange({ etatPerso: option.value, etatExterieur })}
            disabled={loading}
          />
        ))}
      </SectionBox>

      <SectionBox variant="emerald" icon="👨‍👩‍👧" label="Et côté parents / école :">
        {etatExterieurOptions.map(option => (
          <RadioItem
            key={option.value}
            checked={etatExterieur === option.value}
            label={option.label}
            sublabel={option.sub}
            onClick={() => onChange({ etatPerso, etatExterieur: option.value })}
            disabled={loading}
          />
        ))}
      </SectionBox>
    </OnboardingLayout>
  );
};

export default EtatScreen;
